import React from "react";
import Header from "../sharedComponents/header/header";
import {PackageId, PackageModel} from "../../helpers/package";
import {CalculateStore} from "../../stores/calculateStore";
import {inject, observer} from "mobx-react";
import {UiFlagsStore} from "../../stores/uiFlagsStore";
import "./offerCustomizer.scss";
import Packages from "./packages/packages";
import BackButton from "../sharedComponents/backButton/backButton";
import NextButton from "../sharedComponents/nextButton/nextButton";
import {Widget} from "../../helpers/widget";
import {RisksId} from "../../helpers/risk";
import AdditionalInsurances from "./additionalInsurances/additionalInsurances";
import {ErrorMessage, ErrorMessages} from "../../helpers/errorMessage";
import AdditionalQuestions from "./additionalQuestions/additionalQuestions";
import SummaryBox from "../sharedComponents/summaryBox/summaryBox";
import {ClientStore} from "../../stores/clientStore";
import DiscountsAndAdditionalClauses from "./discountsAndAdditionalClauses/discountsAndAdditionalClauses";
import {HttpError} from "../sharedComponents/notification/httpError";
import {CalculationService} from "../../services/services/calculationService";
import StoreCalculationPopup from "./storeCalculationPopup/storeCalculationPopup";
import SaveCalculationButton from "../sharedComponents/saveCalculationButton/saveCalculationButton";
import {StoreCalculationService} from "../../services/services/storeCalculationService";
import {onSaveCalculationButtonClick} from "../../helpers/calculation";
import Loader from "../sharedComponents/loader/Loader";
import {UserStore} from "../../stores/userStore";
import {PolicyStore} from "../../stores/policyStore";
import {NumberOfDamagesInLastThreeYearsId} from "../../helpers/additionalQuestions/numberOfDamagesInLastThreeYears";
import {Discounts} from "../../helpers/discount";
import {initialDiscountsEnum} from "../../helpers/initialDiscounts";
import ReactGA from "react-ga4";
import {UserRole} from "../../helpers/userRole";

interface OfferCustomizerProps {
    calculateStore?: CalculateStore;
    uiFlagsStore?: UiFlagsStore;
    clientStore?: ClientStore;
    calculationService?: CalculationService;
    storeCalculationService?: StoreCalculationService;
    userStore?: UserStore;
    policyStore?: PolicyStore;
}

interface OfferCustomizerState {
    packageErrorMessage: string;
    loadCalculation: boolean;
    isStorePopupOpen: boolean;
}

@inject("calculateStore", "uiFlagsStore", "clientStore", "calculationService", "storeCalculationService", "userStore", "policyStore")
@observer
export default class OfferCustomizer extends React.Component<OfferCustomizerProps, OfferCustomizerState> {
    public constructor(props: any) {

        super(props);

        this.state = {
            packageErrorMessage: "",
            loadCalculation: false,
            isStorePopupOpen: false
        };
    }

    public async componentDidMount() {
        this.props.uiFlagsStore!.setIsClientEndsSelected(false);
        const calculateStore = this.props.calculateStore!;
        const calculationService = this.props.calculationService!;
        const underConstruction = calculateStore.isPropertyUnderConstruction();
        const packages = calculateStore.packages;

        this.handleGaTag("offerCustomizerEntry");

        this.newOfferInitialDiscounts();
        this.renewalInitialDiscounts();

        if (this.props.policyStore?.isPolicyRenewal) {
            await this.props.calculationService?.setRisksNetworkForAllPackages();
        }

        if (packages.has(PackageId.mini) && packages.has(PackageId.midi) && packages.has(PackageId.maxi)) {
            this.setDisableContent(true);

            await calculationService.setRisksNetworkForAllPackages();

            packages.forEach((packageData: PackageModel) => {
                if (calculateStore.noRequiredInsuranceProductsSelectedForPackage(packageData.id)) {
                    this.setErrorMessage("Wybierz produkty do ubezpieczenia.");
                    packageData.calculationResponse = null;
                } else {
                    if (underConstruction && packageData.risks.has(RisksId.riskMode)) {
                        const riskMode = packageData.risks.get(RisksId.riskMode)!;
                        packageData.risks.set(RisksId.riskMode, {...riskMode, available: false});
                    }
                    if (calculateStore.propertyInsurance) {
                        calculationService.refreshPackage(packageData.id);
                        calculationService.refreshPackageForceNewBiznes(packageData.id);
                    }
                }
            });

            if (!ErrorMessage.verifyIfFormErrorMessageIsRendered()) {
                await this.recalculate(false);
            }

            this.setDisableContent(false);
        } else {
            this.setErrorMessage("Wystąpił błąd przy próbie pobrania pakietów.\nSpróbuj ponownie później.");
        }

        this.defineFloodSelectState();
    }

    public render() {
        return (
            <div
                className={`content offer-customizer ${this.props.uiFlagsStore!.isMobile ? "" : "display-flex"}`}>
                {this.state.loadCalculation && this.renderLoader()}
                <div className="left-column">
                    <Header type="big" mainHeader="Dopasuj ofertę do swoich potrzeb"
                    />
                    {this.isHttpRequestError() && (
                        <HttpError
                            requestStatuses={this.props.calculateStore!.allRequestStatuses}
                            defaultErrorMessage={ErrorMessages.response.calculation}
                            type={"http"}/>
                    )}

                    {this.state.packageErrorMessage && this.renderPackagesError()}
                    <Packages
                        refreshPackage={(packageId) => {
                            this.props.calculationService!.refreshPackage(packageId);
                            this.props.calculationService!.refreshPackageForceNewBiznes(packageId);
                        }}
                        disabledButtons={!this.props.calculateStore!.propertyInsurance}
                        setErrorMessage={(errorMessage) => this.setErrorMessage(errorMessage)}
                    />
                    <AdditionalInsurances/>
                    <AdditionalQuestions/>
                    <DiscountsAndAdditionalClauses/>

                    {this.props.uiFlagsStore!.isMobile && (
                        <SummaryBox/>
                    )}

                    {this.renderButtons()}
                </div>

                {!this.props.uiFlagsStore!.isMobile && (
                    <SummaryBox>
                        {this.renderNextButton()}
                    </SummaryBox>
                )}
                <StoreCalculationPopup
                    isOpen={this.state.isStorePopupOpen}
                    parentCalculationId={this.props.calculateStore!.parentCalculationId}
                    waitForParentCalculationId={false}
                    onClose={() => this.setState({isStorePopupOpen: false})}
                />
            </div>
        );
    }

    private renderPackagesError() {
        return (
            <div className="packages-error-message error-message">
                {this.state.packageErrorMessage}
            </div>
        );
    }

    private renderNextButton() {
        if (this.displayCalculateButton()) {
            return (
                <NextButton onClick={() => this.calculateButtonOnClick()}
                            buttonType="calculate"
                />);
        } else {
            return (
                <>
                    {this.displayClientEnds() && (
                        <NextButton
                            key="client-ends"
                            onClick={() => {
                                this.props.uiFlagsStore!.setIsClientEndsSelected(true);
                                this.nextButtonOnClick();
                            }}
                            buttonType="client-ends"
                        />
                    )}
                    <NextButton
                        onClick={() => this.nextButtonOnClick()}
                        buttonType="next"
                    />
                </>
            );
        }
    }

    private renderButtons() {
        const className = (this.displayClientEnds() && !this.displayCalculateButton()) ? "with-client-ends" : "";

        return (
            <div className={`buttons ${className}`}>
                <BackButton onClick={() => this.backButtonOnClick()}/>
                {!this.props.uiFlagsStore!.isDirect
                    && (<SaveCalculationButton
                            onClick={() => {
                                onSaveCalculationButtonClick(this.props.storeCalculationService!, this.props.clientStore!);
                                this.setState({isStorePopupOpen: true});
                            }}/>
                    )}
                {this.renderNextButton()}
            </div>
        );
    }

    private renderLoader() {
        return <div className="offer-loader">
            <Loader/>
            <div className="offer-loader-message">Trwa kalkulacja...</div>
        </div>;
    }

    private goToNextStep() {
        Widget.goToNextStep(this.props.uiFlagsStore!);
    }

    private async calculateButtonOnClick() {
        this.validateAdditionalInsurance();
        const calculateStore = this.props.calculateStore!;
        calculateStore.discounts.validateAll();

        if (ErrorMessage.verifyIfFormWithoutClientsDataErrorMessageIsRendered()) {
            ErrorMessage.scrollToFirstFormErrorMessage();
        } else {
            if (ErrorMessage.verifyIfHttpMessageIsRendered()) {
                ErrorMessage.scrollToFirstErrorMessage();
            }
            const isPropertyInsurance = calculateStore.propertyInsurance;
            this.setDisableContent(true);
            await this.recalculate(isPropertyInsurance);
            this.setRisksError();
            this.setDisableContent(false);
        }

    }

    private nextButtonOnClick() {
        this.validateAdditionalInsurance();
        this.validateAdditionalQuestions();
        this.props.calculateStore!.discounts.validateAll();
        if (ErrorMessage.verifyIfErrorMessageIsRendered()) {
            ErrorMessage.scrollToFirstErrorMessage();
        } else {
            this.goToNextStep();
        }
    }

    private setRisksError() {
        this.setPackagesRiskError(RisksId.burglaryAndTheftMovables, false);
        this.setPackagesRiskError(RisksId.fixedElementsWithBurglaryAndTheft, false);
        const burglaryAndTheftMovablesInsuranceSumErrorCode = "insurance.burglaryAndTheft.movables.individualInsuranceSumInCents.shouldBeLessThanOrEqualTo.\\d+";
        const burglaryAndTheftInsuranceSumErrorCode = "insurance.burglaryAndTheft.fixedElements.insuranceSum.shouldBeLessThanOrEqualTo.\\d+";
        if (this.isHttpRequestError()) {
            const partnerApiErrorCodes = this.getPartnerApiErrorCodesFromCalculations();
            partnerApiErrorCodes?.forEach((errorCode) => {
                if (errorCode.match(burglaryAndTheftMovablesInsuranceSumErrorCode)) {
                    this.setPackagesRiskError(RisksId.burglaryAndTheftMovables, true);
                }
                if (errorCode.match(burglaryAndTheftInsuranceSumErrorCode)) {
                    this.setPackagesRiskError(RisksId.fixedElementsWithBurglaryAndTheft, true);
                }
            });
        }
    }

    private setPackagesRiskError(riskId: RisksId, hasError: boolean) {
        this.props.calculateStore!.packages.forEach((packageData: PackageModel) => {
            this.props.calculateStore!.setErrorForPackageRiskInsuranceSum(packageData.id, riskId, hasError);
        });
    }

    private async recalculate(withPackages: boolean) {
        const calculateStore = this.props.calculateStore!;

        await this.props.calculationService!.recalculate(withPackages);
        if (!calculateStore.calculationResponse) {
            calculateStore.setRequireRecalculate(true);
        }
    }

    private validateAdditionalInsurance() {
        this.props.calculateStore!.additionalInsurances.nonResidentialBuilding.validate();
        this.props.calculateStore!.additionalInsurances.legalProtection.validate();
        this.props.calculateStore!.additionalInsurances.ocAdditionalProperty.validate();
        this.props.calculateStore!.additionalInsurances.catAndDog.validateCatAndDogCount();
    }

    private validateAdditionalQuestions() {
        this.props.clientStore!.insurer.validateInsuredData();
        this.props.calculateStore!.additionalQuestions.businessActivityInBuilding.validateBusinessActivity();
        this.props.calculateStore!.additionalQuestions.partOfFarm.validatePartOfFarm();
        this.props.calculateStore!.additionalQuestions.claimlessYearsIn5Years.validateClaimlessYearsIn5Years();
        this.props.calculateStore!.additionalQuestions.numberOfDamagesInLastThreeYears.validateNumberOfDamagesInLastThreeYears();
        this.props.calculateStore!.additionalQuestions.paymentMode.validatePaymentMode();
        this.props.calculateStore!.additionalQuestions.policyDuration.validatePolicyDuration();
        this.validateInsuredsData();
    }

    private validateInsuredsData() {
        this.props.clientStore!.insureds.forEach(
            (insured) => {
                insured.regon?.validate();
                insured.firstName.validate();
                insured.lastName.validate();
                insured.pesel.validate();
                insured.validateCompanyName();
                insured.legalForm.validate();
            });
    }

    private setDisableContent(disabled: boolean) {
        this.setState({ loadCalculation: disabled });
    }

    private backButtonOnClick() {
        if (!this.props.uiFlagsStore!.isDirect && !this.props.calculateStore!.externalApk && !this.props.calculateStore!.propertyInsuranceApk && !this.props.calculateStore!.oc) {
            this.props.uiFlagsStore!.goToApkStep();
        } else {
            Widget.goToPrevStep(this.props.uiFlagsStore!);
        }

    }


    private setErrorMessage(errorMessage: string) {
        this.setState({ packageErrorMessage: errorMessage });
    }

    private getPartnerApiErrorCodesFromCalculations(): string[] {
        return [...new Set(this.props.calculateStore!.allRequestStatuses
            .map((requestStatus) => requestStatus.partnerApiErrorCodes)
            .filter((code) => !!code)
            .reduce((left, right) => left.concat(right), []))];
    }

    private isHttpRequestError() {
        return this.props.calculateStore!.allRequestStatuses.some((requestStatus) => requestStatus.isError);
    }

    private displayClientEnds() {
        return this.props.uiFlagsStore!.displayClientEnds(this.props.userStore!.roles);
    }

    private displayCalculateButton() {
        return this.props.calculateStore!.requireRecalculate || ErrorMessage.verifyIfHttpMessageIsRendered();
    }

    private isDisableSpecialDiscount() {
        return this.props.calculateStore?.additionalQuestions.numberOfDamagesInLastThreeYears.value
            !== NumberOfDamagesInLastThreeYearsId.zero;
    }

    private newOfferInitialDiscounts(): void {
        if (this.props.uiFlagsStore?.isDirect || this.props.policyStore?.isPolicyRenewal || this.props.uiFlagsStore?.isOfferEdit) {
            return;
        }

        const discountType = UserRole.isDurRole(this.props.userStore?.roles)
            ? Discounts.durManagerDiscount
            : Discounts.managerDiscount;

        this.props.calculateStore?.setDiscount(discountType, initialDiscountsEnum.MANAGER_DISCOUNT);
        this.props.calculateStore?.setDiscount(Discounts.agentDiscount, initialDiscountsEnum.AGENT_DISCOUNT);
    }

    private renewalInitialDiscounts(): void {
        if (this.props.policyStore?.isPolicyRenewal && !this.isDisableSpecialDiscount()) {
            this.props.calculateStore?.setDiscount(Discounts.specialDiscount, initialDiscountsEnum.SPECIAL_DISCOUNT);
        } else {
            this.props.calculateStore?.setDiscount(Discounts.specialDiscount,"0");
        }
    }
    private handleGaTag(action:string) {
        if (this.props.uiFlagsStore?.isDirect) {
            ReactGA.event({category: "event", action: `${action}`});
        }
    }

    private defineFloodSelectState() {

        const {
            calculateStore,
            policyStore,
            uiFlagsStore
        } = this.props;

        if (!calculateStore?.nnw && !policyStore?.isPolicyRenewal && !uiFlagsStore?.isOfferEdit) {
            Object.values(PackageId).forEach((packageId: PackageId) => {
                this.props.calculateStore?.setPackageRisk(packageId, RisksId.flood, true);
            });
        }
    }
}
